export const COUNTRY_LIST = [
  {
    "flagImg": "assets/images/flags/ac.svg",
    "countryName": "Ascension Island",
    "countryCode": 247,
    "shortName": "AC"
  },
  {
    "flagImg": "assets/images/flags/ad.svg",
    "countryName": "Andorra",
    "countryCode": 376,
    "shortName": "AD"
  },
  {
    "flagImg": "assets/images/flags/ae.svg",
    "countryName": "United Arab Emirates",
    "countryCode": 971,
    "shortName": "AE"
  },
  {
    "flagImg": "assets/images/flags/af.svg",
    "countryName": "Afghanistan",
    "countryCode": 93,
    "shortName": "AF"
  },
  {
    "flagImg": "assets/images/flags/ag.svg",
    "countryName": "Antigua and Barbuda",
    "countryCode": 93,
    "shortName": "AG"
  },
  {
    "flagImg": "assets/images/flags/ai.svg",
    "countryName": "Anguilla",
    "countryCode": 1,
    "shortName": "AI"
  },
  {
    "flagImg": "assets/images/flags/am.svg",
    "countryName": "Armenia",
    "countryCode": 374,
    "shortName": "AM"
  },
  {
    "flagImg": "assets/images/flags/ao.svg",
    "countryName": "Angola",
    "countryCode": 244,
    "shortName": "AO"
  },
  {
    "flagImg": "assets/images/flags/aq.svg",
    "countryName": "Antarctica",
    "countryCode": 672,
    "shortName": "AQ"
  },
  {
    "flagImg": "assets/images/flags/ar.svg",
    "countryName": "Argentina",
    "countryCode": 54,
    "shortName": "AR"
  },
  {
    "flagImg": "assets/images/flags/as.svg",
    "countryName": "American Samoa",
    "countryCode": 1,
    "shortName": "AS"
  },
  {
    "flagImg": "assets/images/flags/at.svg",
    "countryName": "Austria",
    "countryCode": 43,
    "shortName": "AT"
  },
  {
    "flagImg": "assets/images/flags/au.svg",
    "countryName": "Australia",
    "countryCode": 61,
    "shortName": "AU"
  },
  {
    "flagImg": "assets/images/flags/aw.svg",
    "countryName": "Aruba",
    "countryCode": 297,
    "shortName": "AW"
  },
  {
    "flagImg": "assets/images/flags/ax.svg",
    "countryName": "Aland Islands",
    "countryCode": 358,
    "shortName": "AX"
  },
  {
    "flagImg": "assets/images/flags/ba.svg",
    "countryName": "Bosnia and Herzegovina",
    "countryCode": 387,
    "shortName": "BA"
  },
  {
    "flagImg": "assets/images/flags/bb.svg",
    "countryName": "Barbados",
    "countryCode": 1,
    "shortName": "BB"
  },
  {
    "flagImg": "assets/images/flags/bd.svg",
    "countryName": "Bangladesh",
    "countryCode": 880,
    "shortName": "BD"
  },
  {
    "flagImg": "assets/images/flags/be.svg",
    "countryName": "Belgium",
    "countryCode": 32,
    "shortName": "BE"
  },
  {
    "flagImg": "assets/images/flags/bf.svg",
    "countryName": "Burkina Faso",
    "countryCode": 226,
    "shortName": "BF"
  },
  {
    "flagImg": "assets/images/flags/bf.svg",
    "countryName": "Bulgaria",
    "countryCode": 359,
    "shortName": "BF"
  },
  {
    "flagImg": "assets/images/flags/bh.svg",
    "countryName": "Bahrain",
    "countryCode": 973,
    "shortName": "BH"
  },
  {
    "flagImg": "assets/images/flags/bi.svg",
    "countryName": "Burundi",
    "countryCode": 257,
    "shortName": "BI"
  },
  {
    "flagImg": "assets/images/flags/bj.svg",
    "countryName": "Benin",
    "countryCode": 229,
    "shortName": "BJ"
  },
  {
    "flagImg": "assets/images/flags/bl.svg",
    "countryName": "Saint Barthélemy",
    "countryCode": 590,
    "shortName": "BL"
  },
  {
    "flagImg": "assets/images/flags/bm.svg",
    "countryName": "Bermuda",
    "countryCode": 1,
    "shortName": "BM"
  },
  {
    "flagImg": "assets/images/flags/bn.svg",
    "countryName": "Brunei Darussalam",
    "countryCode": 673,
    "shortName": "BN"
  },
  {
    "flagImg": "assets/images/flags/bo.svg",
    "countryName": "Bolivia (Plurinational State of)",
    "countryCode": 591,
    "shortName": "BO"
  },
  {
    "flagImg": "assets/images/flags/bq.svg",
    "countryName": "Bonaire, Sint Eustatius and Saba",
    "countryCode": 599,
    "shortName": "BQ"
  },
  {
    "flagImg": "assets/images/flags/br.svg",
    "countryName": "Brazil",
    "countryCode": 55,
    "shortName": "BR"
  },
  {
    "flagImg": "assets/images/flags/bs.svg",
    "countryName": "Bahamas",
    "countryCode": 1,
    "shortName": "BS"
  },
  {
    "flagImg": "assets/images/flags/bt.svg",
    "countryName": "Bhutan",
    "countryCode": 975,
    "shortName": "BT"
  },
  {
    "flagImg": "assets/images/flags/bv.svg",
    "countryName": "Bouvet Island",
    "countryCode": 47,
    "shortName": "BV"
  },
  {
    "flagImg": "assets/images/flags/bw.svg",
    "countryName": "Botswana",
    "countryCode": 267,
    "shortName": "BW"
  },
  {
    "flagImg": "assets/images/flags/by.svg",
    "countryName": "Belarus",
    "countryCode": 375,
    "shortName": "BY"
  },
  {
    "flagImg": "assets/images/flags/bz.svg",
    "countryName": "Belize",
    "countryCode": 501,
    "shortName": "BZ"
  },
  {
    "flagImg": "assets/images/flags/ca.svg",
    "countryName": "Canada",
    "countryCode": 1,
    "shortName": "CA"
  },
  {
    "flagImg": "assets/images/flags/cc.svg",
    "countryName": "Cocos (Keeling) Island",
    "countryCode": 61,
    "shortName": "CC"
  },
  {
    "flagImg": "assets/images/flags/cd.svg",
    "countryName": "Democratic Republic of the Congo",
    "countryCode": 243,
    "shortName": "CD"
  },
  {
    "flagImg": "assets/images/flags/cf.svg",
    "countryName": "Central African Republic",
    "countryCode": 236,
    "shortName": "CF"
  },
  {
    "flagImg": "assets/images/flags/cg.svg",
    "countryName": "Republic of the Congo",
    "countryCode": 243,
    "shortName": "CG"
  },
  {
    "flagImg": "assets/images/flags/ch.svg",
    "countryName": "Switzerland",
    "countryCode": 41,
    "shortName": "CH"
  },
  {
    "flagImg": "assets/images/flags/ci.svg",
    "countryName": "Ivory Coast",
    "countryCode": 225,
    "shortName": "CI"
  },
  {
    "flagImg": "assets/images/flags/ck.svg",
    "countryName": "Cook Islands",
    "countryCode": 682,
    "shortName": "CK"
  },
  {
    "flagImg": "assets/images/flags/cl.svg",
    "countryName": "Chile",
    "countryCode": 56,
    "shortName": "CL"
  },
  {
    "flagImg": "assets/images/flags/cm.svg",
    "countryName": "Cameroon",
    "countryCode": 237,
    "shortName": "CM"
  },
  {
    "flagImg": "assets/images/flags/cn.svg",
    "countryName": "China",
    "countryCode": 86,
    "shortName": "CN"
  },
  {
    "flagImg": "assets/images/flags/co.svg",
    "countryName": "Colombia",
    "countryCode": 57,
    "shortName": "CO"
  },
  {
    "flagImg": "assets/images/flags/cp.svg",
    "countryName": "Clipperton Island",
    "countryCode": 55,
    "shortName": "CP"
  },
  {
    "flagImg": "assets/images/flags/cr.svg",
    "countryName": "Costa Rica",
    "countryCode": 506,
    "shortName": "CR"
  },
  {
    "flagImg": "assets/images/flags/cu.svg",
    "countryName": "Cuba",
    "countryCode": 53,
    "shortName": "CU"
  },
  {
    "flagImg": "assets/images/flags/cv.svg",
    "countryName": "Cabo Verde",
    "countryCode": 238,
    "shortName": "CV"
  },
  {
    "flagImg": "assets/images/flags/cw.svg",
    "countryName": "Curaçao",
    "countryCode": 599,
    "shortName": "CW"
  },
  {
    "flagImg": "assets/images/flags/cx.svg",
    "countryName": "Christmas Island",
    "countryCode": 61,
    "shortName": "CX"
  },
  {
    "flagImg": "assets/images/flags/cy.svg",
    "countryName": "Cyprus",
    "countryCode": 357,
    "shortName": "CY"
  },
  {
    "flagImg": "assets/images/flags/cz.svg",
    "countryName": "Czech Republic",
    "countryCode": 420,
    "shortName": "CZ"
  },
  {
    "flagImg": "assets/images/flags/de.svg",
    "countryName": "Germany",
    "countryCode": 49,
    "shortName": "DE"
  },
  {
    "flagImg": "assets/images/flags/dg.svg",
    "countryName": "Diego Garcia",
    "countryCode": 246,
    "shortName": "DG"
  },
  {
    "flagImg": "assets/images/flags/dj.svg",
    "countryName": "Djibouti",
    "countryCode": 253,
    "shortName": "DJ"
  },
  {
    "flagImg": "assets/images/flags/dk.svg",
    "countryName": "Denmark",
    "countryCode": 45,
    "shortName": "DK"
  },
  {
    "flagImg": "assets/images/flags/dm.svg",
    "countryName": "Dominica",
    "countryCode": 1,
    "shortName": "DM"
  },
  {
    "flagImg": "assets/images/flags/do.svg",
    "countryName": "Dominican Republic",
    "countryCode": 1,
    "shortName": "DO"
  },
  {
    "flagImg": "assets/images/flags/dz.svg",
    "countryName": "Algeria",
    "countryCode": 213,
    "shortName": "DZ"
  },
  {
    "flagImg": "assets/images/flags/ea.svg",
    "countryName": "Ceuta & Melilla",
    "countryCode": 34,
    "shortName": "EA"
  },
  {
    "flagImg": "assets/images/flags/ec.svg",
    "countryName": "Ecuador",
    "countryCode": 593,
    "shortName": "EC"
  },
  {
    "flagImg": "assets/images/flags/ee.svg",
    "countryName": "Estonia",
    "countryCode": 372,
    "shortName": "EE"
  },
  {
    "flagImg": "assets/images/flags/eg.svg",
    "countryName": "Egypt",
    "countryCode": 20,
    "shortName": "EG"
  },
  {
    "flagImg": "assets/images/flags/eh.svg",
    "countryName": "Western Sahara",
    "countryCode": 212,
    "shortName": "EH"
  },
  {
    "flagImg": "assets/images/flags/er.svg",
    "countryName": "Eritrea",
    "countryCode": 291,
    "shortName": "ER"
  },
  {
    "flagImg": "assets/images/flags/es.svg",
    "countryName": "Spain",
    "countryCode": 34,
    "shortName": "ES"
  },
  {
    "flagImg": "assets/images/flags/es-ct.svg",
    "countryName": "Catalonia",
    "countryCode": 34,
    "shortName": "ES-CT"
  },
  {
    "flagImg": "assets/images/flags/es-ga.svg",
    "countryName": "Galicia",
    "countryCode": 34,
    "shortName": "ES-GA"
  },
  {
    "flagImg": "assets/images/flags/et.svg",
    "countryName": "Ethiopia",
    "countryCode": 251,
    "shortName": "ET"
  },
  {
    "flagImg": "assets/images/flags/eu.svg",
    "countryName": "Europe",
    "countryCode": 3,
    "shortName": "EU"
  },
  {
    "flagImg": "assets/images/flags/fi.svg",
    "countryName": "Finland",
    "countryCode": 358,
    "shortName": "FI"
  },
  {
    "flagImg": "assets/images/flags/fj.svg",
    "countryName": "Fiji",
    "countryCode": 679,
    "shortName": "FJ"
  },
  {
    "flagImg": "assets/images/flags/fk.svg",
    "countryName": "Falkland Islands",
    "countryCode": 500,
    "shortName": "FK"
  },
  {
    "flagImg": "assets/images/flags/fm.svg",
    "countryName": "Federated States of Micronesia",
    "countryCode": 691,
    "shortName": "FM"
  },
  {
    "flagImg": "assets/images/flags/fo.svg",
    "countryName": "Faroe Islands",
    "countryCode": 298,
    "shortName": "FO"
  },
  {
    "flagImg": "assets/images/flags/fr.svg",
    "countryName": "France",
    "countryCode": 33,
    "shortName": "FR"
  },
  {
    "flagImg": "assets/images/flags/ga.svg",
    "countryName": "Gabon",
    "countryCode": 241,
    "shortName": "GA"
  },
  {
    "flagImg": "assets/images/flags/gb-eng.svg",
    "countryName": "England",
    "countryCode": 44,
    "shortName": "GB-ENG"
  },
  {
    "flagImg": "assets/images/flags/gb-nir.svg",
    "countryName": "Northern Ireland",
    "countryCode": 44,
    "shortName": "GB-NIR"
  },
  {
    "flagImg": "assets/images/flags/gb-sct.svg",
    "countryName": "Scotland",
    "countryCode": 44,
    "shortName": "GB-SCT"
  },
  {
    "flagImg": "assets/images/flags/gb-wls.svg",
    "countryName": "Wales",
    "countryCode": 44,
    "shortName": "GB-WLS"
  },
  {
    "flagImg": "assets/images/flags/gd.svg",
    "countryName": "Grenada",
    "countryCode": 1,
    "shortName": "GD"
  },
  {
    "flagImg": "assets/images/flags/ge.svg",
    "countryName": "Georgia",
    "countryCode": 995,
    "shortName": "GE"
  },
  {
    "flagImg": "assets/images/flags/gf.svg",
    "countryName": "French Guiana",
    "countryCode": 594,
    "shortName": "GF"
  },
  {
    "flagImg": "assets/images/flags/gg.svg",
    "countryName": "Guernsey",
    "countryCode": 44,
    "shortName": "GG"
  },
  {
    "flagImg": "assets/images/flags/gh.svg",
    "countryName": "Ghana",
    "countryCode": 233,
    "shortName": "GH"
  },
  {
    "flagImg": "assets/images/flags/gi.svg",
    "countryName": "Gibraltar",
    "countryCode": 350,
    "shortName": "GI"
  },
  {
    "flagImg": "assets/images/flags/gl.svg",
    "countryName": "Greenland",
    "countryCode": 299,
    "shortName": "GL"
  },
  {
    "flagImg": "assets/images/flags/gm.svg",
    "countryName": "Gambia",
    "countryCode": 220,
    "shortName": "GM"
  },
  {
    "flagImg": "assets/images/flags/gn.svg",
    "countryName": "Guinea",
    "countryCode": 224,
    "shortName": "GN"
  },
  {
    "flagImg": "assets/images/flags/gp.svg",
    "countryName": "Guadeloupe",
    "countryCode": 590,
    "shortName": "GP"
  },
  {
    "flagImg": "assets/images/flags/gq.svg",
    "countryName": "Equatorial Guinea",
    "countryCode": 240,
    "shortName": "GQ"
  },
  {
    "flagImg": "assets/images/flags/gr.svg",
    "countryName": "Greece",
    "countryCode": 30,
    "shortName": "GR"
  },
  {
    "flagImg": "assets/images/flags/gs.svg",
    "countryName": "South Georgia and the South Sandwich Islands",
    "countryCode": 500,
    "shortName": "GS"
  },
  {
    "flagImg": "assets/images/flags/gt.svg",
    "countryName": "Guatemala",
    "countryCode": 502,
    "shortName": "GT"
  },
  {
    "flagImg": "assets/images/flags/gu.svg",
    "countryName": "Guam",
    "countryCode": 1,
    "shortName": "GU"
  },
  {
    "flagImg": "assets/images/flags/gw.svg",
    "countryName": "Guinea-Bissau",
    "countryCode": 245,
    "shortName": "GW"
  },
  {
    "flagImg": "assets/images/flags/gy.svg",
    "countryName": "Guyana",
    "countryCode": 592,
    "shortName": "GY"
  },
  {
    "flagImg": "assets/images/flags/hk.svg",
    "countryName": "Hong Kong",
    "countryCode": 852,
    "shortName": "HK"
  },
  {
    "flagImg": "assets/images/flags/hn.svg",
    "countryName": "Honduras",
    "countryCode": 504,
    "shortName": "HN"
  },
  {
    "flagImg": "assets/images/flags/hr.svg",
    "countryName": "Croatia",
    "countryCode": 385,
    "shortName": "HR"
  },
  {
    "flagImg": "assets/images/flags/ht.svg",
    "countryName": "Haiti",
    "countryCode": 509,
    "shortName": "HT"
  },
  {
    "flagImg": "assets/images/flags/hu.svg",
    "countryName": "Hungary",
    "countryCode": 36,
    "shortName": "HU"
  },
  {
    "flagImg": "assets/images/flags/id.svg",
    "countryName": "Indonesia",
    "countryCode": 62,
    "shortName": "ID"
  },
  {
    "flagImg": "assets/images/flags/ie.svg",
    "countryName": "Ireland",
    "countryCode": 353,
    "shortName": "IE"
  },
  {
    "flagImg": "assets/images/flags/il.svg",
    "countryName": "Israel",
    "countryCode": 972,
    "shortName": "IL"
  },
  {
    "flagImg": "assets/images/flags/im.svg",
    "countryName": "Isle of Man",
    "countryCode": 44,
    "shortName": "IM"
  },
  {
    "flagImg": "assets/images/flags/in.svg",
    "countryName": "India",
    "countryCode": 91,
    "shortName": "IN"
  },
  {
    "flagImg": "assets/images/flags/io.svg",
    "countryName": "British Indian Ocean Territory",
    "countryCode": 246,
    "shortName": "IO"
  },
  {
    "flagImg": "assets/images/flags/iq.svg",
    "countryName": "Iraq",
    "countryCode": 964,
    "shortName": "IQ"
  },
  {
    "flagImg": "assets/images/flags/ir.svg",
    "countryName": "Iran (Islamic Republic of)",
    "countryCode": 98,
    "shortName": "IR"
  },
  {
    "flagImg": "assets/images/flags/is.svg",
    "countryName": "Iceland",
    "countryCode": 354,
    "shortName": "IS"
  },
  {
    "flagImg": "assets/images/flags/it.svg",
    "countryName": "Italy",
    "countryCode": 39,
    "shortName": "IT"
  },
  {
    "flagImg": "assets/images/flags/je.svg",
    "countryName": "Jersey",
    "countryCode": 44,
    "shortName": "JE"
  },
  {
    "flagImg": "assets/images/flags/jm.svg",
    "countryName": "Jamaica",
    "countryCode": 1,
    "shortName": "JM"
  },
  {
    "flagImg": "assets/images/flags/jo.svg",
    "countryName": "Jordan",
    "countryCode": 962,
    "shortName": "JO"
  },
  {
    "flagImg": "assets/images/flags/jp.svg",
    "countryName": "Japan",
    "countryCode": 81,
    "shortName": "JP"
  },
  {
    "flagImg": "assets/images/flags/ke.svg",
    "countryName": "Kenya",
    "countryCode": 254,
    "shortName": "KE"
  },
  {
    "flagImg": "assets/images/flags/kg.svg",
    "countryName": "Kyrgyzstan",
    "countryCode": 996,
    "shortName": "KG"
  },
  {
    "flagImg": "assets/images/flags/kh.svg",
    "countryName": "Cambodia",
    "countryCode": 855,
    "shortName": "KH"
  },
  {
    "flagImg": "assets/images/flags/ki.svg",
    "countryName": "Kiribati",
    "countryCode": 686,
    "shortName": "KI"
  },
  {
    "flagImg": "assets/images/flags/km.svg",
    "countryName": "Comoros",
    "countryCode": 269,
    "shortName": "KM"
  },
  {
    "flagImg": "assets/images/flags/kn.svg",
    "countryName": "Saint Kitts and Nevis",
    "countryCode": 1,
    "shortName": "KN"
  },
  {
    "flagImg": "assets/images/flags/kp.svg",
    "countryName": "North Korea",
    "countryCode": 850,
    "shortName": "KP"
  },
  {
    "flagImg": "assets/images/flags/kr.svg",
    "countryName": "South Korea",
    "countryCode": 82,
    "shortName": "KR"
  },
  {
    "flagImg": "assets/images/flags/kw.svg",
    "countryName": "Kuwait",
    "countryCode": 965,
    "shortName": "KW"
  },
  {
    "flagImg": "assets/images/flags/ky.svg",
    "countryName": "Cayman Islands",
    "countryCode": 1,
    "shortName": "KY"
  },
  {
    "flagImg": "assets/images/flags/kz.svg",
    "countryName": "Kazakhstan",
    "countryCode": 7,
    "shortName": "KZ"
  },
  {
    "flagImg": "assets/images/flags/la.svg",
    "countryName": "Laos",
    "countryCode": 856,
    "shortName": "LA"
  },
  {
    "flagImg": "assets/images/flags/lb.svg",
    "countryName": "Lebanon",
    "countryCode": 961,
    "shortName": "LB"
  },
  {
    "flagImg": "assets/images/flags/lc.svg",
    "countryName": "Saint Lucia",
    "countryCode": 1,
    "shortName": "LC"
  },
  {
    "flagImg": "assets/images/flags/li.svg",
    "countryName": "Liechtenstein",
    "countryCode": 423,
    "shortName": "LI"
  },
  {
    "flagImg": "assets/images/flags/lk.svg",
    "countryName": "Sri Lanka",
    "countryCode": 94,
    "shortName": "LK"
  },
  {
    "flagImg": "assets/images/flags/lr.svg",
    "countryName": "Liberia",
    "countryCode": 231,
    "shortName": "LR"
  },
  {
    "flagImg": "assets/images/flags/ls.svg",
    "countryName": "Lesotho",
    "countryCode": 266,
    "shortName": "LS"
  },
  {
    "flagImg": "assets/images/flags/lt.svg",
    "countryName": "Lithuania",
    "countryCode": 370,
    "shortName": "LT"
  },
  {
    "flagImg": "assets/images/flags/lu.svg",
    "countryName": "Luxembourg",
    "countryCode": 352,
    "shortName": "LU"
  },
  {
    "flagImg": "assets/images/flags/lv.svg",
    "countryName": "Latvia",
    "countryCode": 371,
    "shortName": "LV"
  },
  {
    "flagImg": "assets/images/flags/ly.svg",
    "countryName": "Libya",
    "countryCode": 218,
    "shortName": "LY"
  },
  {
    "flagImg": "assets/images/flags/ma.svg",
    "countryName": "Morocco",
    "countryCode": 212,
    "shortName": "MA"
  },
  {
    "flagImg": "assets/images/flags/mc.svg",
    "countryName": "Monaco",
    "countryCode": 377,
    "shortName": "MC"
  },
  {
    "flagImg": "assets/images/flags/md.svg",
    "countryName": "Moldova",
    "countryCode": 373,
    "shortName": "MD"
  },
  {
    "flagImg": "assets/images/flags/me.svg",
    "countryName": "Montenegro",
    "countryCode": 382,
    "shortName": "ME"
  },
  {
    "flagImg": "assets/images/flags/mf.svg",
    "countryName": "Saint Martin",
    "countryCode": 721,
    "shortName": "MF"
  },
  {
    "flagImg": "assets/images/flags/mg.svg",
    "countryName": "Madagascar",
    "countryCode": 261,
    "shortName": "MG"
  },
  {
    "flagImg": "assets/images/flags/mh.svg",
    "countryName": "Marshall Islands",
    "countryCode": 692,
    "shortName": "MH"
  },
  {
    "flagImg": "assets/images/flags/mk.svg",
    "countryName": "North Macedonia",
    "countryCode": 389,
    "shortName": "MK"
  },
  {
    "flagImg": "assets/images/flags/ml.svg",
    "countryName": "Mali",
    "countryCode": 223,
    "shortName": "ML"
  },
  {
    "flagImg": "assets/images/flags/mm.svg",
    "countryName": "Myanmar",
    "countryCode": 95,
    "shortName": "MM"
  },
  {
    "flagImg": "assets/images/flags/mn.svg",
    "countryName": "Mongolia",
    "countryCode": 976,
    "shortName": "MN"
  },
  {
    "flagImg": "assets/images/flags/mo.svg",
    "countryName": "Macau",
    "countryCode": 853,
    "shortName": "MO"
  },
  {
    "flagImg": "assets/images/flags/mp.svg",
    "countryName": "Northern Mariana Islands",
    "countryCode": 1,
    "shortName": "MP"
  },
  {
    "flagImg": "assets/images/flags/mq.svg",
    "countryName": "Martinique",
    "countryCode": 596,
    "shortName": "MQ"
  },
  {
    "flagImg": "assets/images/flags/mr.svg",
    "countryName": "Mauritania",
    "countryCode": 222,
    "shortName": "MR"
  },
  {
    "flagImg": "assets/images/flags/ms.svg",
    "countryName": "Montserrat",
    "countryCode": 1,
    "shortName": "MS"
  },
  {
    "flagImg": "assets/images/flags/mt.svg",
    "countryName": "Malta",
    "countryCode": 356,
    "shortName": "MT"
  },
  {
    "flagImg": "assets/images/flags/mu.svg",
    "countryName": "Mauritius",
    "countryCode": 230,
    "shortName": "MU"
  },
  {
    "flagImg": "assets/images/flags/mv.svg",
    "countryName": "Maldives",
    "countryCode": 960,
    "shortName": "MV"
  },
  {
    "flagImg": "assets/images/flags/mw.svg",
    "countryName": "Malawi",
    "countryCode": 265,
    "shortName": "MW"
  },
  {
    "flagImg": "assets/images/flags/mx.svg",
    "countryName": "Mexico",
    "countryCode": 52,
    "shortName": "MX"
  },
  {
    "flagImg": "assets/images/flags/my.svg",
    "countryName": "Malaysia",
    "countryCode": 60,
    "shortName": "MY"
  },
  {
    "flagImg": "assets/images/flags/mz.svg",
    "countryName": "Mozambique",
    "countryCode": 258,
    "shortName": "MZ"
  },
  {
    "flagImg": "assets/images/flags/na.svg",
    "countryName": "Namibia",
    "countryCode": 264,
    "shortName": "NA"
  },
  {
    "flagImg": "assets/images/flags/nc.svg",
    "countryName": "New Caledonia",
    "countryCode": 687,
    "shortName": "NC"
  },
  {
    "flagImg": "assets/images/flags/ne.svg",
    "countryName": "Niger",
    "countryCode": 227,
    "shortName": "NE"
  },
  {
    "flagImg": "assets/images/flags/nf.svg",
    "countryName": "Norfolk Island",
    "countryCode": 672,
    "shortName": "NF"
  },
  {
    "flagImg": "assets/images/flags/ng.svg",
    "countryName": "Nigeria",
    "countryCode": 234,
    "shortName": "NG"
  },
  {
    "flagImg": "assets/images/flags/ni.svg",
    "countryName": "Nicaragua",
    "countryCode": 505,
    "shortName": "NI"
  },
  {
    "flagImg": "assets/images/flags/nl.svg",
    "countryName": "Netherlands",
    "countryCode": 31,
    "shortName": "NL"
  },
  {
    "flagImg": "assets/images/flags/no.svg",
    "countryName": "Norway",
    "countryCode": 47,
    "shortName": "NO"
  },
  {
    "flagImg": "assets/images/flags/np.svg",
    "countryName": "Nepal",
    "countryCode": 977,
    "shortName": "NP"
  },
  {
    "flagImg": "assets/images/flags/nr.svg",
    "countryName": "Nauru",
    "countryCode": 674,
    "shortName": "NR"
  },
  {
    "flagImg": "assets/images/flags/nu.svg",
    "countryName": "Niue",
    "countryCode": 683,
    "shortName": "NU"
  },
  {
    "flagImg": "assets/images/flags/nz.svg",
    "countryName": "New Zealand",
    "countryCode": 64,
    "shortName": "NZ"
  },
  {
    "flagImg": "assets/images/flags/om.svg",
    "countryName": "Oman",
    "countryCode": 968,
    "shortName": "OM"
  },
  {
    "flagImg": "assets/images/flags/pa.svg",
    "countryName": "Panama",
    "countryCode": 507,
    "shortName": "PA"
  },
  {
    "flagImg": "assets/images/flags/pe.svg",
    "countryName": "Peru",
    "countryCode": 51,
    "shortName": "PE"
  },
  {
    "flagImg": "assets/images/flags/pf.svg",
    "countryName": "French Polynesia",
    "countryCode": 689,
    "shortName": "PF"
  },
  {
    "flagImg": "assets/images/flags/pg.svg",
    "countryName": "Papua New Guinea",
    "countryCode": 675,
    "shortName": "PG"
  },
  {
    "flagImg": "assets/images/flags/ph.svg",
    "countryName": "Philippines",
    "countryCode": 63,
    "shortName": "PH"
  },
  {
    "flagImg": "assets/images/flags/pk.svg",
    "countryName": "Pakistan",
    "countryCode": 92,
    "shortName": "PK"
  },
  {
    "flagImg": "assets/images/flags/pl.svg",
    "countryName": "Poland",
    "countryCode": 48,
    "shortName": "PL"
  },
  {
    "flagImg": "assets/images/flags/pm.svg",
    "countryName": "Saint Pierre and Miquelon",
    "countryCode": 508,
    "shortName": "PM"
  },
  {
    "flagImg": "assets/images/flags/pn.svg",
    "countryName": "Pitcairn",
    "countryCode": 64,
    "shortName": "PN"
  },
  {
    "flagImg": "assets/images/flags/pr.svg",
    "countryName": "Puerto Rico",
    "countryCode": 1,
    "shortName": "PR"
  },
  {
    "flagImg": "assets/images/flags/ps.svg",
    "countryName": "State of Palestine",
    "countryCode": 970,
    "shortName": "PS"
  },
  {
    "flagImg": "assets/images/flags/pt.svg",
    "countryName": "Portugal",
    "countryCode": 351,
    "shortName": "PT"
  },
  {
    "flagImg": "assets/images/flags/pw.svg",
    "countryName": "Palau",
    "countryCode": 680,
    "shortName": "PW"
  },
  {
    "flagImg": "assets/images/flags/py.svg",
    "countryName": "Paraguay",
    "countryCode": 595,
    "shortName": "PY"
  },
  {
    "flagImg": "assets/images/flags/qa.svg",
    "countryName": "Qatar",
    "countryCode": 974,
    "shortName": "QA"
  },
  {
    "flagImg": "assets/images/flags/re.svg",
    "countryName": "Réunion",
    "countryCode": 262,
    "shortName": "RE"
  },
  {
    "flagImg": "assets/images/flags/ro.svg",
    "countryName": "Romania",
    "countryCode": 40,
    "shortName": "RO"
  },
  {
    "flagImg": "assets/images/flags/rs.svg",
    "countryName": "Serbia",
    "countryCode": 381,
    "shortName": "RS"
  },
  {
    "flagImg": "assets/images/flags/ru.svg",
    "countryName": "Russia",
    "countryCode": 7,
    "shortName": "RU"
  },
  {
    "flagImg": "assets/images/flags/rw.svg",
    "countryName": "Rwanda",
    "countryCode": 250,
    "shortName": "RW"
  },
  {
    "flagImg": "assets/images/flags/sa.svg",
    "countryName": "Saudi Arabia",
    "countryCode": 966,
    "shortName": "SA"
  },
  {
    "flagImg": "assets/images/flags/sb.svg",
    "countryName": "Solomon Islands",
    "countryCode": 677,
    "shortName": "SB"
  },
  {
    "flagImg": "assets/images/flags/sc.svg",
    "countryName": "Seychelles",
    "countryCode": 248,
    "shortName": "SC"
  },
  {
    "flagImg": "assets/images/flags/sd.svg",
    "countryName": "Sudan",
    "countryCode": 249,
    "shortName": "SD"
  },
  {
    "flagImg": "assets/images/flags/se.svg",
    "countryName": "Sweden",
    "countryCode": 46,
    "shortName": "SE"
  },
  {
    "flagImg": "assets/images/flags/sg.svg",
    "countryName": "Singapore",
    "countryCode": 65,
    "shortName": "SG"
  },
  {
    "flagImg": "assets/images/flags/si.svg",
    "countryName": "Slovenia",
    "countryCode": 386,
    "shortName": "SI"
  },
  {
    "flagImg": "assets/images/flags/sj.svg",
    "countryName": "Svalbard and Jan Mayen",
    "countryCode": 47,
    "shortName": "SJ"
  },
  {
    "flagImg": "assets/images/flags/sk.svg",
    "countryName": "Slovakia",
    "countryCode": 421,
    "shortName": "SK"
  },
  {
    "flagImg": "assets/images/flags/sl.svg",
    "countryName": "Sierra Leone",
    "countryCode": 232,
    "shortName": "SL"
  },
  {
    "flagImg": "assets/images/flags/sm.svg",
    "countryName": "San Marino",
    "countryCode": 378,
    "shortName": "SM"
  },
  {
    "flagImg": "assets/images/flags/sn.svg",
    "countryName": "Senegal",
    "countryCode": 221,
    "shortName": "SN"
  },
  {
    "flagImg": "assets/images/flags/so.svg",
    "countryName": "Somalia",
    "countryCode": 252,
    "shortName": "SO"
  },
  {
    "flagImg": "assets/images/flags/sr.svg",
    "countryName": "Suriname",
    "countryCode": 597,
    "shortName": "SR"
  },
  {
    "flagImg": "assets/images/flags/ss.svg",
    "countryName": "South Sudan",
    "countryCode": 211,
    "shortName": "SS"
  },
  {
    "flagImg": "assets/images/flags/st.svg",
    "countryName": "Sao Tome and Principe",
    "countryCode": 239,
    "shortName": "ST"
  },
  {
    "flagImg": "assets/images/flags/sv.svg",
    "countryName": "El Salvador",
    "countryCode": 503,
    "shortName": "SV"
  },
  {
    "flagImg": "assets/images/flags/sx.svg",
    "countryName": "Sint Maarten",
    "countryCode": 721,
    "shortName": "SX"
  },
  {
    "flagImg": "assets/images/flags/sy.svg",
    "countryName": "Syria",
    "countryCode": 963,
    "shortName": "SY"
  },
  {
    "flagImg": "assets/images/flags/sz.svg",
    "countryName": "Eswatini",
    "countryCode": 268,
    "shortName": "SZ"
  },
  {
    "flagImg": "assets/images/flags/ta.svg",
    "countryName": "Tristan da Cunha",
    "countryCode": 290,
    "shortName": "TA"
  },
  {
    "flagImg": "assets/images/flags/tc.svg",
    "countryName": "Turks and Caicos Islands",
    "countryCode": 1,
    "shortName": "TC"
  },
  {
    "flagImg": "assets/images/flags/td.svg",
    "countryName": "Chad",
    "countryCode": 235,
    "shortName": "TD"
  },
  {
    "flagImg": "assets/images/flags/tg.svg",
    "countryName": "Togo",
    "countryCode": 228,
    "shortName": "TG"
  },
  {
    "flagImg": "assets/images/flags/th.svg",
    "countryName": "Thailand",
    "countryCode": 66,
    "shortName": "TH"
  },
  {
    "flagImg": "assets/images/flags/tj.svg",
    "countryName": "Tajikistan",
    "countryCode": 992,
    "shortName": "TJ"
  },
  {
    "flagImg": "assets/images/flags/tk.svg",
    "countryName": "Tokelau",
    "countryCode": 690,
    "shortName": "TK"
  },
  {
    "flagImg": "assets/images/flags/tl.svg",
    "countryName": "Timor-Leste",
    "countryCode": 670,
    "shortName": "TL"
  },
  {
    "flagImg": "assets/images/flags/tm.svg",
    "countryName": "Turkmenistan",
    "countryCode": 993,
    "shortName": "TM"
  },
  {
    "flagImg": "assets/images/flags/tn.svg",
    "countryName": "Tunisia",
    "countryCode": 216,
    "shortName": "TN"
  },
  {
    "flagImg": "assets/images/flags/to.svg",
    "countryName": "Tonga",
    "countryCode": 676,
    "shortName": "TO"
  },
  {
    "flagImg": "assets/images/flags/tr.svg",
    "countryName": "Turkey",
    "countryCode": 90,
    "shortName": "TR"
  },
  {
    "flagImg": "assets/images/flags/tt.svg",
    "countryName": "Trinidad and Tobago",
    "countryCode": 1,
    "shortName": "TT"
  },
  {
    "flagImg": "assets/images/flags/tv.svg",
    "countryName": "Tuvalu",
    "countryCode": 688,
    "shortName": "TV"
  },
  {
    "flagImg": "assets/images/flags/tw.svg",
    "countryName": "Taiwan",
    "countryCode": 886,
    "shortName": "TW"
  },
  {
    "flagImg": "assets/images/flags/tz.svg",
    "countryName": "Tanzania",
    "countryCode": 255,
    "shortName": "TZ"
  },
  {
    "flagImg": "assets/images/flags/ua.svg",
    "countryName": "Ukraine",
    "countryCode": 380,
    "shortName": "UA"
  },
  {
    "flagImg": "assets/images/flags/ug.svg",
    "countryName": "Uganda",
    "countryCode": 256,
    "shortName": "UG"
  },
  {
    "flagImg": "assets/images/flags/us.svg",
    "countryName": "United States of America",
    "countryCode": 1,
    "shortName": "US"
  },
  {
    "flagImg": "assets/images/flags/uy.svg",
    "countryName": "Uruguay",
    "countryCode": 598,
    "shortName": "UY"
  },
  {
    "flagImg": "assets/images/flags/uz.svg",
    "countryName": "Uzbekistan",
    "countryCode": 998,
    "shortName": "UZ"
  },
  {
    "flagImg": "assets/images/flags/va.svg",
    "countryName": "Holy See",
    "countryCode": 379,
    "shortName": "VA"
  },
  {
    "flagImg": "assets/images/flags/vc.svg",
    "countryName": "Saint Vincent and the Grenadines",
    "countryCode": 1,
    "shortName": "VC"
  },
  {
    "flagImg": "assets/images/flags/ve.svg",
    "countryName": "Venezuela (Bolivarian Republic of)",
    "countryCode": 58,
    "shortName": "VE"
  },
  {
    "flagImg": "assets/images/flags/vg.svg",
    "countryName": "Virgin Islands (British)",
    "countryCode": 1,
    "shortName": "VG"
  },
  {
    "flagImg": "assets/images/flags/vi.svg",
    "countryName": "Virgin Islands (U.S.)",
    "countryCode": 1,
    "shortName": "VI"
  },
  {
    "flagImg": "assets/images/flags/vn.svg",
    "countryName": "Vietnam",
    "countryCode": 84,
    "shortName": "VN"
  },
  {
    "flagImg": "assets/images/flags/vu.svg",
    "countryName": "Vanuatu",
    "countryCode": 678,
    "shortName": "VU"
  },
  {
    "flagImg": "assets/images/flags/wf.svg",
    "countryName": "Wallis and Futuna",
    "countryCode": 681,
    "shortName": "WF"
  },
  {
    "flagImg": "assets/images/flags/ws.svg",
    "countryName": "Samoa",
    "countryCode": 685,
    "shortName": "WS"
  },
  {
    "flagImg": "assets/images/flags/xk.svg",
    "countryName": "Kosovo",
    "countryCode": 383,
    "shortName": "XK"
  },
  {
    "flagImg": "assets/images/flags/ye.svg",
    "countryName": "Yemen",
    "countryCode": 967,
    "shortName": "YE"
  },
  {
    "flagImg": "assets/images/flags/yt.svg",
    "countryName": "Mayotte",
    "countryCode": 262,
    "shortName": "YT"
  },
  {
    "flagImg": "assets/images/flags/za.svg",
    "countryName": "South Africa",
    "countryCode": 27,
    "shortName": "ZA"
  },
  {
    "flagImg": "assets/images/flags/zm.svg",
    "countryName": "Zambia",
    "countryCode": 260,
    "shortName": "ZM"
  },
  {
    "flagImg": "assets/images/flags/zw.svg",
    "countryName": "Zimbabwe",
    "countryCode": 263,
    "shortName": "ZW"
  }
];

export const SECTOR_LIST = [
	{ name: 'Homland Security (HLS)'},
	{ name: 'Banking'},
	{ name: 'Medical'},
	{ name: 'Human Resource (HR)'},
	{ name: 'Insurance'}
];

export const COUNTRY_PHONE_CODE_LIST = [
	{
			"id": 1,
			"flagImg": "assets/images/flags/ac.svg",
			"countryName": "Ascension Island",
			"countryCode": 247
	},
	{
			"id": 2,
			"flagImg": "assets/images/flags/ad.svg",
			"countryName": "Andorra",
			"countryCode": 376
	},
	{
			"id": 3,
			"flagImg": "assets/images/flags/ae.svg",
			"countryName": "United Arab Emirates",
			"countryCode": 971
	},
	{
			"id": 4,
			"flagImg": "assets/images/flags/af.svg",
			"countryName": "Afghanistan",
			"countryCode": 93
	},
	{
			"id": 5,
			"flagImg": "assets/images/flags/ag.svg",
			"countryName": "Antigua and Barbuda",
			"countryCode": 93
	},
	{
			"id": 6,
			"flagImg": "assets/images/flags/ai.svg",
			"countryName": "Anguilla",
			"countryCode": 1
	},
	{
			"id": 7,
			"flagImg": "assets/images/flags/am.svg",
			"countryName": "Armenia",
			"countryCode": 374
	},
	{
			"id": 8,
			"flagImg": "assets/images/flags/ao.svg",
			"countryName": "Angola",
			"countryCode": 244
	},
	{
			"id": 9,
			"flagImg": "assets/images/flags/aq.svg",
			"countryName": "Antarctica",
			"countryCode": 672
	},
	{
			"id": 10,
			"flagImg": "assets/images/flags/ar.svg",
			"countryName": "Argentina",
			"countryCode": 54
	},
	{
			"id": 11,
			"flagImg": "assets/images/flags/as.svg",
			"countryName": "American Samoa",
			"countryCode": 1
	},
	{
			"id": 12,
			"flagImg": "assets/images/flags/at.svg",
			"countryName": "Austria",
			"countryCode": 43
	},
	{
			"id": 13,
			"flagImg": "assets/images/flags/au.svg",
			"countryName": "Australia",
			"countryCode": 61
	},
	{
			"id": 14,
			"flagImg": "assets/images/flags/aw.svg",
			"countryName": "Aruba",
			"countryCode": 297
	},
	{
			"id": 15,
			"flagImg": "assets/images/flags/ax.svg",
			"countryName": "Aland Islands",
			"countryCode": 358
	},
	{
			"id": 16,
			"flagImg": "assets/images/flags/ba.svg",
			"countryName": "Bosnia and Herzegovina",
			"countryCode": 387
	},
	{
			"id": 17,
			"flagImg": "assets/images/flags/bb.svg",
			"countryName": "Barbados",
			"countryCode": 1
	},
	{
			"id": 18,
			"flagImg": "assets/images/flags/bd.svg",
			"countryName": "Bangladesh",
			"countryCode": 880
	},
	{
			"id": 19,
			"flagImg": "assets/images/flags/be.svg",
			"countryName": "Belgium",
			"countryCode": 32
	},
	{
			"id": 20,
			"flagImg": "assets/images/flags/bf.svg",
			"countryName": "Burkina Faso",
			"countryCode": 226
	},
	{
			"id": 21,
			"flagImg": "assets/images/flags/bf.svg",
			"countryName": "Bulgaria",
			"countryCode": 359
	},
	{
			"id": 22,
			"flagImg": "assets/images/flags/bh.svg",
			"countryName": "Bahrain",
			"countryCode": 973
	},
	{
			"id": 23,
			"flagImg": "assets/images/flags/bi.svg",
			"countryName": "Burundi",
			"countryCode": 257
	},
	{
			"id": 24,
			"flagImg": "assets/images/flags/bj.svg",
			"countryName": "Benin",
			"countryCode": 229
	},
	{
			"id": 25,
			"flagImg": "assets/images/flags/bl.svg",
			"countryName": "Saint Barthélemy",
			"countryCode": 590
	},
	{
			"id": 26,
			"flagImg": "assets/images/flags/bm.svg",
			"countryName": "Bermuda",
			"countryCode": 1
	},
	{
			"id": 27,
			"flagImg": "assets/images/flags/bn.svg",
			"countryName": "Brunei Darussalam",
			"countryCode": 673
	},
	{
			"id": 28,
			"flagImg": "assets/images/flags/bo.svg",
			"countryName": "Bolivia (Plurinational State of)",
			"countryCode": 591
	},
	{
			"id": 29,
			"flagImg": "assets/images/flags/bq.svg",
			"countryName": "Bonaire, Sint Eustatius and Saba",
			"countryCode": 599
	},
	{
			"id": 30,
			"flagImg": "assets/images/flags/br.svg",
			"countryName": "Brazil",
			"countryCode": 55
	},
	{
			"id": 31,
			"flagImg": "assets/images/flags/bs.svg",
			"countryName": "Bahamas",
			"countryCode": 1
	},
	{
			"id": 32,
			"flagImg": "assets/images/flags/bt.svg",
			"countryName": "Bhutan",
			"countryCode": 975
	},
	{
			"id": 33,
			"flagImg": "assets/images/flags/bv.svg",
			"countryName": "Bouvet Island",
			"countryCode": 47
	},
	{
			"id": 34,
			"flagImg": "assets/images/flags/bw.svg",
			"countryName": "Botswana",
			"countryCode": 267
	},
	{
			"id": 35,
			"flagImg": "assets/images/flags/by.svg",
			"countryName": "Belarus",
			"countryCode": 375
	},
	{
			"id": 36,
			"flagImg": "assets/images/flags/bz.svg",
			"countryName": "Belize",
			"countryCode": 501
	},
	{
			"id": 37,
			"flagImg": "assets/images/flags/ca.svg",
			"countryName": "Canada",
			"countryCode": 1
	},
	{
			"id": 38,
			"flagImg": "assets/images/flags/cc.svg",
			"countryName": "Cocos (Keeling) Island",
			"countryCode": 61
	},
	{
			"id": 39,
			"flagImg": "assets/images/flags/cd.svg",
			"countryName": "Democratic Republic of the Congo",
			"countryCode": 243
	},
	{
			"id": 40,
			"flagImg": "assets/images/flags/cf.svg",
			"countryName": "Central African Republic",
			"countryCode": 236
	},
	{
			"id": 41,
			"flagImg": "assets/images/flags/cg.svg",
			"countryName": "Republic of the Congo",
			"countryCode": 243
	},
	{
			"id": 42,
			"flagImg": "assets/images/flags/ch.svg",
			"countryName": "Switzerland",
			"countryCode": 41
	},
	{
			"id": 43,
			"flagImg": "assets/images/flags/ci.svg",
			"countryName": "Ivory Coast",
			"countryCode": 225
	},
	{
			"id": 44,
			"flagImg": "assets/images/flags/ck.svg",
			"countryName": "Cook Islands",
			"countryCode": 682
	},
	{
			"id": 45,
			"flagImg": "assets/images/flags/cl.svg",
			"countryName": "Chile",
			"countryCode": 56
	},
	{
			"id": 46,
			"flagImg": "assets/images/flags/cm.svg",
			"countryName": "Cameroon",
			"countryCode": 237
	},
	{
			"id": 47,
			"flagImg": "assets/images/flags/cn.svg",
			"countryName": "China",
			"countryCode": 86
	},
	{
			"id": 48,
			"flagImg": "assets/images/flags/co.svg",
			"countryName": "Colombia",
			"countryCode": 57
	},
	{
			"id": 49,
			"flagImg": "assets/images/flags/cp.svg",
			"countryName": "Clipperton Island",
			"countryCode": 55
	},
	{
			"id": 50,
			"flagImg": "assets/images/flags/cr.svg",
			"countryName": "Costa Rica",
			"countryCode": 506
	},
	{
			"id": 51,
			"flagImg": "assets/images/flags/cu.svg",
			"countryName": "Cuba",
			"countryCode": 53
	},
	{
			"id": 52,
			"flagImg": "assets/images/flags/cv.svg",
			"countryName": "Cabo Verde",
			"countryCode": 238
	},
	{
			"id": 53,
			"flagImg": "assets/images/flags/cw.svg",
			"countryName": "Curaçao",
			"countryCode": 599
	},
	{
			"id": 54,
			"flagImg": "assets/images/flags/cx.svg",
			"countryName": "Christmas Island",
			"countryCode": 61
	},
	{
			"id": 55,
			"flagImg": "assets/images/flags/cy.svg",
			"countryName": "Cyprus",
			"countryCode": 357
	},
	{
			"id": 56,
			"flagImg": "assets/images/flags/cz.svg",
			"countryName": "Czech Republic",
			"countryCode": 420
	},
	{
			"id": 57,
			"flagImg": "assets/images/flags/de.svg",
			"countryName": "Germany",
			"countryCode": 49
	},
	{
			"id": 58,
			"flagImg": "assets/images/flags/dg.svg",
			"countryName": "Diego Garcia",
			"countryCode": 246
	},
	{
			"id": 59,
			"flagImg": "assets/images/flags/dj.svg",
			"countryName": "Djibouti",
			"countryCode": 253
	},
	{
			"id": 60,
			"flagImg": "assets/images/flags/dk.svg",
			"countryName": "Denmark",
			"countryCode": 45
	},
	{
			"id": 61,
			"flagImg": "assets/images/flags/dm.svg",
			"countryName": "Dominica",
			"countryCode": 1
	},
	{
			"id": 62,
			"flagImg": "assets/images/flags/do.svg",
			"countryName": "Dominican Republic",
			"countryCode": 1
	},
	{
			"id": 63,
			"flagImg": "assets/images/flags/dz.svg",
			"countryName": "Algeria",
			"countryCode": 213
	},
	{
			"id": 64,
			"flagImg": "assets/images/flags/ea.svg",
			"countryName": "Ceuta & Melilla",
			"countryCode": 34
	},
	{
			"id": 65,
			"flagImg": "assets/images/flags/ec.svg",
			"countryName": "Ecuador",
			"countryCode": 593
	},
	{
			"id": 66,
			"flagImg": "assets/images/flags/ee.svg",
			"countryName": "Estonia",
			"countryCode": 372
	},
	{
			"id": 67,
			"flagImg": "assets/images/flags/eg.svg",
			"countryName": "Egypt",
			"countryCode": 20
	},
	{
			"id": 68,
			"flagImg": "assets/images/flags/eh.svg",
			"countryName": "Western Sahara",
			"countryCode": 212
	},
	{
			"id": 69,
			"flagImg": "assets/images/flags/er.svg",
			"countryName": "Eritrea",
			"countryCode": 291
	},
	{
			"id": 70,
			"flagImg": "assets/images/flags/es.svg",
			"countryName": "Spain",
			"countryCode": 34
	},
	{
			"id": 71,
			"flagImg": "assets/images/flags/es-ct.svg",
			"countryName": "Catalonia",
			"countryCode": 34
	},
	{
			"id": 72,
			"flagImg": "assets/images/flags/es-ga.svg",
			"countryName": "Galicia",
			"countryCode": 34
	},
	{
			"id": 73,
			"flagImg": "assets/images/flags/et.svg",
			"countryName": "Ethiopia",
			"countryCode": 251
	},
	{
			"id": 74,
			"flagImg": "assets/images/flags/eu.svg",
			"countryName": "Europe",
			"countryCode": 3
	},
	{
			"id": 75,
			"flagImg": "assets/images/flags/fi.svg",
			"countryName": "Finland",
			"countryCode": 358
	},
	{
			"id": 76,
			"flagImg": "assets/images/flags/fj.svg",
			"countryName": "Fiji",
			"countryCode": 679
	},
	{
			"id": 77,
			"flagImg": "assets/images/flags/fk.svg",
			"countryName": "Falkland Islands",
			"countryCode": 500
	},
	{
			"id": 78,
			"flagImg": "assets/images/flags/fm.svg",
			"countryName": "Federated States of Micronesia",
			"countryCode": 691
	},
	{
			"id": 79,
			"flagImg": "assets/images/flags/fo.svg",
			"countryName": "Faroe Islands",
			"countryCode": 298
	},
	{
			"id": 80,
			"flagImg": "assets/images/flags/fr.svg",
			"countryName": "France",
			"countryCode": 33
	},
	{
			"id": 81,
			"flagImg": "assets/images/flags/ga.svg",
			"countryName": "Gabon",
			"countryCode": 241
	},
	{
			"id": 82,
			"flagImg": "assets/images/flags/gb-eng.svg",
			"countryName": "England",
			"countryCode": 44
	},
	{
			"id": 83,
			"flagImg": "assets/images/flags/gb-nir.svg",
			"countryName": "Northern Ireland",
			"countryCode": 44
	},
	{
			"id": 84,
			"flagImg": "assets/images/flags/gb-sct.svg",
			"countryName": "Scotland",
			"countryCode": 44
	},
	{
			"id": 85,
			"flagImg": "assets/images/flags/gb-wls.svg",
			"countryName": "Wales",
			"countryCode": 44
	},
	{
			"id": 86,
			"flagImg": "assets/images/flags/gd.svg",
			"countryName": "Grenada",
			"countryCode": 1
	},
	{
			"id": 87,
			"flagImg": "assets/images/flags/ge.svg",
			"countryName": "Georgia",
			"countryCode": 995
	},
	{
			"id": 88,
			"flagImg": "assets/images/flags/gf.svg",
			"countryName": "French Guiana",
			"countryCode": 594
	},
	{
			"id": 99,
			"flagImg": "assets/images/flags/gg.svg",
			"countryName": "Guernsey",
			"countryCode": 44
	},
	{
			"id": 90,
			"flagImg": "assets/images/flags/gh.svg",
			"countryName": "Ghana",
			"countryCode": 233
	},
	{
			"id": 91,
			"flagImg": "assets/images/flags/gi.svg",
			"countryName": "Gibraltar",
			"countryCode": 350
	},
	{
			"id": 92,
			"flagImg": "assets/images/flags/gl.svg",
			"countryName": "Greenland",
			"countryCode": 299
	},
	{
			"id": 93,
			"flagImg": "assets/images/flags/gm.svg",
			"countryName": "Gambia",
			"countryCode": 220
	},
	{
			"id": 94,
			"flagImg": "assets/images/flags/gn.svg",
			"countryName": "Guinea",
			"countryCode": 224
	},
	{
			"id": 95,
			"flagImg": "assets/images/flags/gp.svg",
			"countryName": "Guadeloupe",
			"countryCode": 590
	},
	{
			"id": 96,
			"flagImg": "assets/images/flags/gq.svg",
			"countryName": "Equatorial Guinea",
			"countryCode": 240
	},
	{
			"id": 97,
			"flagImg": "assets/images/flags/gr.svg",
			"countryName": "Greece",
			"countryCode": 30
	},
	{
			"id": 98,
			"flagImg": "assets/images/flags/gs.svg",
			"countryName": "South Georgia and the South Sandwich Islands",
			"countryCode": 500
	},
	{
			"id": 99,
			"flagImg": "assets/images/flags/gt.svg",
			"countryName": "Guatemala",
			"countryCode": 502
	},
	{
			"id": 100,
			"flagImg": "assets/images/flags/gu.svg",
			"countryName": "Guam",
			"countryCode": 1
	},
	{
			"id": 101,
			"flagImg": "assets/images/flags/gw.svg",
			"countryName": "Guinea-Bissau",
			"countryCode": 245
	},
	{
			"id": 102,
			"flagImg": "assets/images/flags/gy.svg",
			"countryName": "Guyana",
			"countryCode": 592
	},
	{
			"id": 103,
			"flagImg": "assets/images/flags/hk.svg",
			"countryName": "Hong Kong",
			"countryCode": 852
	},
	{
			"id": 104,
			"flagImg": "assets/images/flags/hn.svg",
			"countryName": "Honduras",
			"countryCode": 504
	},
	{
			"id": 105,
			"flagImg": "assets/images/flags/hr.svg",
			"countryName": "Croatia",
			"countryCode": 385
	},
	{
			"id": 106,
			"flagImg": "assets/images/flags/ht.svg",
			"countryName": "Haiti",
			"countryCode": 509
	},
	{
			"id": 107,
			"flagImg": "assets/images/flags/hu.svg",
			"countryName": "Hungary",
			"countryCode": 36
	},
	{
			"id": 108,
			"flagImg": "assets/images/flags/id.svg",
			"countryName": "Indonesia",
			"countryCode": 62
	},
	{
			"id": 109,
			"flagImg": "assets/images/flags/ie.svg",
			"countryName": "Ireland",
			"countryCode": 353
	},
	{
			"id": 110,
			"flagImg": "assets/images/flags/il.svg",
			"countryName": "Israel",
			"countryCode": 972
	},
	{
			"id": 111,
			"flagImg": "assets/images/flags/im.svg",
			"countryName": "Isle of Man",
			"countryCode": 44
	},
	{
			"id": 112,
			"flagImg": "assets/images/flags/in.svg",
			"countryName": "India",
			"countryCode": 91
	},
	{
			"id": 113,
			"flagImg": "assets/images/flags/io.svg",
			"countryName": "British Indian Ocean Territory",
			"countryCode": 246
	},
	{
			"id": 114,
			"flagImg": "assets/images/flags/iq.svg",
			"countryName": "Iraq",
			"countryCode": 964
	},
	{
			"id": 115,
			"flagImg": "assets/images/flags/ir.svg",
			"countryName": "Iran (Islamic Republic of)",
			"countryCode": 98
	},
	{
			"id": 116,
			"flagImg": "assets/images/flags/is.svg",
			"countryName": "Iceland",
			"countryCode": 354
	},
	{
			"id": 117,
			"flagImg": "assets/images/flags/it.svg",
			"countryName": "Italy",
			"countryCode": 39
	},
	{
			"id": 118,
			"flagImg": "assets/images/flags/je.svg",
			"countryName": "Jersey",
			"countryCode": 44
	},
	{
			"id": 119,
			"flagImg": "assets/images/flags/jm.svg",
			"countryName": "Jamaica",
			"countryCode": 1
	},
	{
			"id": 120,
			"flagImg": "assets/images/flags/jo.svg",
			"countryName": "Jordan",
			"countryCode": 962
	},
	{
			"id": 121,
			"flagImg": "assets/images/flags/jp.svg",
			"countryName": "Japan",
			"countryCode": 81
	},
	{
			"id": 122,
			"flagImg": "assets/images/flags/ke.svg",
			"countryName": "Kenya",
			"countryCode": 254
	},
	{
			"id": 123,
			"flagImg": "assets/images/flags/kg.svg",
			"countryName": "Kyrgyzstan",
			"countryCode": 996
	},
	{
			"id": 124,
			"flagImg": "assets/images/flags/kh.svg",
			"countryName": "Cambodia",
			"countryCode": 855
	},
	{
			"id": 125,
			"flagImg": "assets/images/flags/ki.svg",
			"countryName": "Kiribati",
			"countryCode": 686
	},
	{
			"id": 126,
			"flagImg": "assets/images/flags/km.svg",
			"countryName": "Comoros",
			"countryCode": 269
	},
	{
			"id": 127,
			"flagImg": "assets/images/flags/kn.svg",
			"countryName": "Saint Kitts and Nevis",
			"countryCode": 1
	},
	{
			"id": 128,
			"flagImg": "assets/images/flags/kp.svg",
			"countryName": "North Korea",
			"countryCode": 850
	},
	{
			"id": 129,
			"flagImg": "assets/images/flags/kr.svg",
			"countryName": "South Korea",
			"countryCode": 82
	},
	{
			"id": 130,
			"flagImg": "assets/images/flags/kw.svg",
			"countryName": "Kuwait",
			"countryCode": 965
	},
	{
			"id": 131,
			"flagImg": "assets/images/flags/ky.svg",
			"countryName": "Cayman Islands",
			"countryCode": 1
	},
	{
			"id": 132,
			"flagImg": "assets/images/flags/kz.svg",
			"countryName": "Kazakhstan",
			"countryCode": 7
	},
	{
			"id": 133,
			"flagImg": "assets/images/flags/la.svg",
			"countryName": "Laos",
			"countryCode": 856
	},
	{
			"id": 134,
			"flagImg": "assets/images/flags/lb.svg",
			"countryName": "Lebanon",
			"countryCode": 961
	},
	{
			"id": 135,
			"flagImg": "assets/images/flags/lc.svg",
			"countryName": "Saint Lucia",
			"countryCode": 1
	},
	{
			"id": 136,
			"flagImg": "assets/images/flags/li.svg",
			"countryName": "Liechtenstein",
			"countryCode": 423
	},
	{
			"id": 137,
			"flagImg": "assets/images/flags/lk.svg",
			"countryName": "Sri Lanka",
			"countryCode": 94
	},
	{
			"id": 138,
			"flagImg": "assets/images/flags/lr.svg",
			"countryName": "Liberia",
			"countryCode": 231
	},
	{
			"id": 139,
			"flagImg": "assets/images/flags/ls.svg",
			"countryName": "Lesotho",
			"countryCode": 266
	},
	{
			"id": 140,
			"flagImg": "assets/images/flags/lt.svg",
			"countryName": "Lithuania",
			"countryCode": 370
	},
	{
			"id": 141,
			"flagImg": "assets/images/flags/lu.svg",
			"countryName": "Luxembourg",
			"countryCode": 352
	},
	{
			"id": 142,
			"flagImg": "assets/images/flags/lv.svg",
			"countryName": "Latvia",
			"countryCode": 371
	},
	{
			"id": 143,
			"flagImg": "assets/images/flags/ly.svg",
			"countryName": "Libya",
			"countryCode": 218
	},
	{
			"id": 144,
			"flagImg": "assets/images/flags/ma.svg",
			"countryName": "Morocco",
			"countryCode": 212
	},
	{
			"id": 145,
			"flagImg": "assets/images/flags/mc.svg",
			"countryName": "Monaco",
			"countryCode": 377
	},
	{
			"id": 146,
			"flagImg": "assets/images/flags/md.svg",
			"countryName": "Moldova",
			"countryCode": 373
	},
	{
			"id": 147,
			"flagImg": "assets/images/flags/me.svg",
			"countryName": "Montenegro",
			"countryCode": 382
	},
	{
			"id": 148,
			"flagImg": "assets/images/flags/mf.svg",
			"countryName": "Saint Martin",
			"countryCode": 721
	},
	{
			"id": 149,
			"flagImg": "assets/images/flags/mg.svg",
			"countryName": "Madagascar",
			"countryCode": 261
	},
	{
			"id": 150,
			"flagImg": "assets/images/flags/mh.svg",
			"countryName": "Marshall Islands",
			"countryCode": 692
	},
	{
			"id": 151,
			"flagImg": "assets/images/flags/mk.svg",
			"countryName": "North Macedonia",
			"countryCode": 389
	},
	{
			"id": 152,
			"flagImg": "assets/images/flags/ml.svg",
			"countryName": "Mali",
			"countryCode": 223
	},
	{
			"id": 153,
			"flagImg": "assets/images/flags/mm.svg",
			"countryName": "Myanmar",
			"countryCode": 95
	},
	{
			"id": 154,
			"flagImg": "assets/images/flags/mn.svg",
			"countryName": "Mongolia",
			"countryCode": 976
	},
	{
			"id": 155,
			"flagImg": "assets/images/flags/mo.svg",
			"countryName": "Macau",
			"countryCode": 853
	},
	{
			"id": 156,
			"flagImg": "assets/images/flags/mp.svg",
			"countryName": "Northern Mariana Islands",
			"countryCode": 1
	},
	{
			"id": 157,
			"flagImg": "assets/images/flags/mq.svg",
			"countryName": "Martinique",
			"countryCode": 596
	},
	{
			"id": 158,
			"flagImg": "assets/images/flags/mr.svg",
			"countryName": "Mauritania",
			"countryCode": 222
	},
	{
			"id": 159,
			"flagImg": "assets/images/flags/ms.svg",
			"countryName": "Montserrat",
			"countryCode": 1
	},
	{
			"id": 160,
			"flagImg": "assets/images/flags/mt.svg",
			"countryName": "Malta",
			"countryCode": 356
	},
	{
			"id": 161,
			"flagImg": "assets/images/flags/mu.svg",
			"countryName": "Mauritius",
			"countryCode": 230
	},
	{
			"id": 162,
			"flagImg": "assets/images/flags/mv.svg",
			"countryName": "Maldives",
			"countryCode": 960
	},
	{
			"id": 163,
			"flagImg": "assets/images/flags/mw.svg",
			"countryName": "Malawi",
			"countryCode": 265
	},
	{
			"id": 164,
			"flagImg": "assets/images/flags/mx.svg",
			"countryName": "Mexico",
			"countryCode": 52
	},
	{
			"id": 165,
			"flagImg": "assets/images/flags/my.svg",
			"countryName": "Malaysia",
			"countryCode": 60
	},
	{
			"id": 166,
			"flagImg": "assets/images/flags/mz.svg",
			"countryName": "Mozambique",
			"countryCode": 258
	},
	{
			"id": 167,
			"flagImg": "assets/images/flags/na.svg",
			"countryName": "Namibia",
			"countryCode": 264
	},
	{
			"id": 168,
			"flagImg": "assets/images/flags/nc.svg",
			"countryName": "New Caledonia",
			"countryCode": 687
	},
	{
			"id": 169,
			"flagImg": "assets/images/flags/ne.svg",
			"countryName": "Niger",
			"countryCode": 227
	},
	{
			"id": 170,
			"flagImg": "assets/images/flags/nf.svg",
			"countryName": "Norfolk Island",
			"countryCode": 672
	},
	{
			"id": 171,
			"flagImg": "assets/images/flags/ng.svg",
			"countryName": "Nigeria",
			"countryCode": 234
	},
	{
			"id": 172,
			"flagImg": "assets/images/flags/ni.svg",
			"countryName": "Nicaragua",
			"countryCode": 505
	},
	{
			"id": 173,
			"flagImg": "assets/images/flags/nl.svg",
			"countryName": "Netherlands",
			"countryCode": 31
	},
	{
			"id": 174,
			"flagImg": "assets/images/flags/no.svg",
			"countryName": "Norway",
			"countryCode": 47
	},
	{
			"id": 175,
			"flagImg": "assets/images/flags/np.svg",
			"countryName": "Nepal",
			"countryCode": 977
	},
	{
			"id": 176,
			"flagImg": "assets/images/flags/nr.svg",
			"countryName": "Nauru",
			"countryCode": 674
	},
	{
			"id": 177,
			"flagImg": "assets/images/flags/nu.svg",
			"countryName": "Niue",
			"countryCode": 683
	},
	{
			"id": 178,
			"flagImg": "assets/images/flags/nz.svg",
			"countryName": "New Zealand",
			"countryCode": 64
	},
	{
			"id": 179,
			"flagImg": "assets/images/flags/om.svg",
			"countryName": "Oman",
			"countryCode": 968
	},
	{
			"id": 180,
			"flagImg": "assets/images/flags/pa.svg",
			"countryName": "Panama",
			"countryCode": 507
	},
	{
			"id": 181,
			"flagImg": "assets/images/flags/pe.svg",
			"countryName": "Peru",
			"countryCode": 51
	},
	{
			"id": 182,
			"flagImg": "assets/images/flags/pf.svg",
			"countryName": "French Polynesia",
			"countryCode": 689
	},
	{
			"id": 183,
			"flagImg": "assets/images/flags/pg.svg",
			"countryName": "Papua New Guinea",
			"countryCode": 675
	},
	{
			"id": 184,
			"flagImg": "assets/images/flags/ph.svg",
			"countryName": "Philippines",
			"countryCode": 63
	},
	{
			"id": 185,
			"flagImg": "assets/images/flags/pk.svg",
			"countryName": "Pakistan",
			"countryCode": 92
	},
	{
			"id": 186,
			"flagImg": "assets/images/flags/pl.svg",
			"countryName": "Poland",
			"countryCode": 48
	},
	{
			"id": 187,
			"flagImg": "assets/images/flags/pm.svg",
			"countryName": "Saint Pierre and Miquelon",
			"countryCode": 508
	},
	{
			"id": 188,
			"flagImg": "assets/images/flags/pn.svg",
			"countryName": "Pitcairn",
			"countryCode": 64
	},
	{
			"id": 189,
			"flagImg": "assets/images/flags/pr.svg",
			"countryName": "Puerto Rico",
			"countryCode": 1
	},
	{
			"id": 190,
			"flagImg": "assets/images/flags/ps.svg",
			"countryName": "State of Palestine",
			"countryCode": 970
	},
	{
			"id": 191,
			"flagImg": "assets/images/flags/pt.svg",
			"countryName": "Portugal",
			"countryCode": 351
	},
	{
			"id": 192,
			"flagImg": "assets/images/flags/pw.svg",
			"countryName": "Palau",
			"countryCode": 680
	},
	{
			"id": 193,
			"flagImg": "assets/images/flags/py.svg",
			"countryName": "Paraguay",
			"countryCode": 595
	},
	{
			"id": 194,
			"flagImg": "assets/images/flags/qa.svg",
			"countryName": "Qatar",
			"countryCode": 974
	},
	{
			"id": 195,
			"flagImg": "assets/images/flags/re.svg",
			"countryName": "Réunion",
			"countryCode": 262
	},
	{
			"id": 196,
			"flagImg": "assets/images/flags/ro.svg",
			"countryName": "Romania",
			"countryCode": 40
	},
	{
			"id": 197,
			"flagImg": "assets/images/flags/rs.svg",
			"countryName": "Serbia",
			"countryCode": 381
	},
	{
			"id": 198,
			"flagImg": "assets/images/flags/ru.svg",
			"countryName": "Russia",
			"countryCode": 7
	},
	{
			"id": 199,
			"flagImg": "assets/images/flags/rw.svg",
			"countryName": "Rwanda",
			"countryCode": 250
	},
	{
			"id": 200,
			"flagImg": "assets/images/flags/sa.svg",
			"countryName": "Saudi Arabia",
			"countryCode": 966
	},
	{
			"id": 201,
			"flagImg": "assets/images/flags/sb.svg",
			"countryName": "Solomon Islands",
			"countryCode": 677
	},
	{
			"id": 202,
			"flagImg": "assets/images/flags/sc.svg",
			"countryName": "Seychelles",
			"countryCode": 248
	},
	{
			"id": 203,
			"flagImg": "assets/images/flags/sd.svg",
			"countryName": "Sudan",
			"countryCode": 249
	},
	{
			"id": 204,
			"flagImg": "assets/images/flags/se.svg",
			"countryName": "Sweden",
			"countryCode": 46
	},
	{
			"id": 205,
			"flagImg": "assets/images/flags/sg.svg",
			"countryName": "Singapore",
			"countryCode": 65
	},
	{
			"id": 207,
			"flagImg": "assets/images/flags/si.svg",
			"countryName": "Slovenia",
			"countryCode": 386
	},
	{
			"id": 208,
			"flagImg": "assets/images/flags/sj.svg",
			"countryName": "Svalbard and Jan Mayen",
			"countryCode": 47
	},
	{
			"id": 209,
			"flagImg": "assets/images/flags/sk.svg",
			"countryName": "Slovakia",
			"countryCode": 421
	},
	{
			"id": 210,
			"flagImg": "assets/images/flags/sl.svg",
			"countryName": "Sierra Leone",
			"countryCode": 232
	},
	{
			"id": 212,
			"flagImg": "assets/images/flags/sm.svg",
			"countryName": "San Marino",
			"countryCode": 378
	},
	{
			"id": 213,
			"flagImg": "assets/images/flags/sn.svg",
			"countryName": "Senegal",
			"countryCode": 221
	},
	{
			"id": 214,
			"flagImg": "assets/images/flags/so.svg",
			"countryName": "Somalia",
			"countryCode": 252
	},
	{
			"id": 215,
			"flagImg": "assets/images/flags/sr.svg",
			"countryName": "Suriname",
			"countryCode": 597
	},
	{
			"id": 216,
			"flagImg": "assets/images/flags/ss.svg",
			"countryName": "South Sudan",
			"countryCode": 211
	},
	{
			"id": 217,
			"flagImg": "assets/images/flags/st.svg",
			"countryName": "Sao Tome and Principe",
			"countryCode": 239
	},
	{
			"id": 218,
			"flagImg": "assets/images/flags/sv.svg",
			"countryName": "El Salvador",
			"countryCode": 503
	},
	{
			"id": 219,
			"flagImg": "assets/images/flags/sx.svg",
			"countryName": "Sint Maarten",
			"countryCode": 721
	},
	{
			"id": 220,
			"flagImg": "assets/images/flags/sy.svg",
			"countryName": "Syria",
			"countryCode": 963
	},
	{
			"id": 221,
			"flagImg": "assets/images/flags/sz.svg",
			"countryName": "Eswatini",
			"countryCode": 268
	},
	{
			"id": 222,
			"flagImg": "assets/images/flags/ta.svg",
			"countryName": "Tristan da Cunha",
			"countryCode": 290
	},
	{
			"id": 223,
			"flagImg": "assets/images/flags/tc.svg",
			"countryName": "Turks and Caicos Islands",
			"countryCode": 1
	},
	{
			"id": 224,
			"flagImg": "assets/images/flags/td.svg",
			"countryName": "Chad",
			"countryCode": 235
	},
	{
			"id": 225,
			"flagImg": "assets/images/flags/tg.svg",
			"countryName": "Togo",
			"countryCode": 228
	},
	{
			"id": 226,
			"flagImg": "assets/images/flags/th.svg",
			"countryName": "Thailand",
			"countryCode": 66
	},
	{
			"id": 227,
			"flagImg": "assets/images/flags/tj.svg",
			"countryName": "Tajikistan",
			"countryCode": 992
	},
	{
			"id": 228,
			"flagImg": "assets/images/flags/tk.svg",
			"countryName": "Tokelau",
			"countryCode": 690
	},
	{
			"id": 229,
			"flagImg": "assets/images/flags/tl.svg",
			"countryName": "Timor-Leste",
			"countryCode": 670
	},
	{
			"id": 230,
			"flagImg": "assets/images/flags/tm.svg",
			"countryName": "Turkmenistan",
			"countryCode": 993
	},
	{
			"id": 231,
			"flagImg": "assets/images/flags/tn.svg",
			"countryName": "Tunisia",
			"countryCode": 216
	},
	{
			"id": 232,
			"flagImg": "assets/images/flags/to.svg",
			"countryName": "Tonga",
			"countryCode": 676
	},
	{
			"id": 233,
			"flagImg": "assets/images/flags/tr.svg",
			"countryName": "Turkey",
			"countryCode": 90
	},
	{
			"id": 234,
			"flagImg": "assets/images/flags/tt.svg",
			"countryName": "Trinidad and Tobago",
			"countryCode": 1
	},
	{
			"id": 235,
			"flagImg": "assets/images/flags/tv.svg",
			"countryName": "Tuvalu",
			"countryCode": 688
	},
	{
			"id": 236,
			"flagImg": "assets/images/flags/tw.svg",
			"countryName": "Taiwan",
			"countryCode": 886
	},
	{
			"id": 237,
			"flagImg": "assets/images/flags/tz.svg",
			"countryName": "Tanzania",
			"countryCode": 255
	},
	{
			"id": 238,
			"flagImg": "assets/images/flags/ua.svg",
			"countryName": "Ukraine",
			"countryCode": 380
	},
	{
			"id": 239,
			"flagImg": "assets/images/flags/ug.svg",
			"countryName": "Uganda",
			"countryCode": 256
	},
	{
			"id": 240,
			"flagImg": "assets/images/flags/us.svg",
			"countryName": "United States of America",
			"countryCode": 1
	},
	{
			"id": 242,
			"flagImg": "assets/images/flags/uy.svg",
			"countryName": "Uruguay",
			"countryCode": 598
	},
	{
			"id": 243,
			"flagImg": "assets/images/flags/uz.svg",
			"countryName": "Uzbekistan",
			"countryCode": 998
	},
	{
			"id": 244,
			"flagImg": "assets/images/flags/va.svg",
			"countryName": "Holy See",
			"countryCode": 379
	},
	{
			"id": 245,
			"flagImg": "assets/images/flags/vc.svg",
			"countryName": "Saint Vincent and the Grenadines",
			"countryCode": 1
	},
	{
			"id": 246,
			"flagImg": "assets/images/flags/ve.svg",
			"countryName": "Venezuela (Bolivarian Republic of)",
			"countryCode": 58
	},
	{
			"id": 247,
			"flagImg": "assets/images/flags/vg.svg",
			"countryName": "Virgin Islands (British)",
			"countryCode": 1
	},
	{
			"id": 248,
			"flagImg": "assets/images/flags/vi.svg",
			"countryName": "Virgin Islands (U.S.)",
			"countryCode": 1
	},
	{
			"id": 249,
			"flagImg": "assets/images/flags/vn.svg",
			"countryName": "Vietnam",
			"countryCode": 84
	},
	{
			"id": 250,
			"flagImg": "assets/images/flags/vu.svg",
			"countryName": "Vanuatu",
			"countryCode": 678
	},
	{
			"id": 251,
			"flagImg": "assets/images/flags/wf.svg",
			"countryName": "Wallis and Futuna",
			"countryCode": 681
	},
	{
			"id": 252,
			"flagImg": "assets/images/flags/ws.svg",
			"countryName": "Samoa",
			"countryCode": 685
	},
	{
			"id": 253,
			"flagImg": "assets/images/flags/xk.svg",
			"countryName": "Kosovo",
			"countryCode": 383
	},
	{
			"id": 254,
			"flagImg": "assets/images/flags/ye.svg",
			"countryName": "Yemen",
			"countryCode": 967
	},
	{
			"id": 255,
			"flagImg": "assets/images/flags/yt.svg",
			"countryName": "Mayotte",
			"countryCode": 262
	},
	{
			"id": 256,
			"flagImg": "assets/images/flags/za.svg",
			"countryName": "South Africa",
			"countryCode": 27
	},
	{
			"id": 257,
			"flagImg": "assets/images/flags/zm.svg",
			"countryName": "Zambia",
			"countryCode": 260
	},
	{
			"id": 258,
			"flagImg": "assets/images/flags/zw.svg",
			"countryName": "Zimbabwe",
			"countryCode": 263
	}
];

export const REPORT_LANGUAGES = [
	{ name: 'English', prefix: 'EN' },
	{ name: 'Hebrew', prefix: 'HE' },
	{ name: 'Spanish', prefix: 'ES' },
	{ name: 'French', prefix: 'FR' },
	{ name: 'German', prefix: 'DE' },
	{ name: 'Italian', prefix: 'IT' },
	{ name: 'Portuguese', prefix: 'PT' },
	{ name: 'Russian', prefix: 'RU' },
	{ name: 'Japanese', prefix: 'JA' },
	{ name: 'Chinese (Simplified)', prefix: 'ZH' },
	{ name: 'Arabic', prefix: 'AR' },
	{ name: 'Dutch', prefix: 'NL' },
	{ name: 'Korean', prefix: 'KO' },
	{ name: 'Turkish', prefix: 'TR' },
	{ name: 'Ukrainian', prefix: 'UK' },
	{ name: 'Polish', prefix: 'PL' },
  { name: 'Thai', prefix: 'TH' }
];

export const DUMMY_REPORTS = [
  {
    id: "uuid-101",
    protocol: "Janus_protocol_2_6",
    template_name: "credibility_template",
    template: { "name": "Credibility", "value": "credibility_template", "client_tone": "Security Manager" },
    version: "a1b2c3d4",
    created_at: "2026-01-14",
    context_snippet: "Candidate interview for senior security role at...",
    video_context: "Candidate interview for senior security role at the new downtown branch. Focus on integrity and past employment gaps.",
    header_data: {
      "Classification": "CONFIDENTIAL",
      "Subject": "John Doe (ID: 5521)",
      "Date of Issue": "2026-01-14",
      "Prepared By": "Analyst A. Smith",
      "Source Material": "Video Analysis"
    },
    languages: [
      { code: "EN", name: "English", status: "Success", file_path: "path/to/en.md", date: "2026-01-14" },
      { code: "HE", name: "Hebrew", status: "Success", file_path: "path/to/he.md", date: "2026-01-14" }
    ]
  },
  {
    id: "uuid-102",
    protocol: "Janus_protocol_2_6",
    template_name: "profiling_template",
    template: { "name": "Profiling", "value": "profiling_template", "client_tone": "Occupational psychologist" },
    version: "9z8y7x6w",
    created_at: "2026-01-14",
    context_snippet: "Suspect interrogation regarding theft incident...",
    video_context: "Suspect interrogation regarding theft incident in the warehouse. Pay attention to nervous ticks when money is mentioned.",
    header_data: {
      "Classification": "SECRET",
      "Subject": "Suspect 404",
      "Date of Issue": "2026-01-14",
      "Prepared By": "Investigator Cohen",
      "Source Material": "Interrogation Room 2"
    },
    languages: [
      { code: "EN", name: "English", status: "Generating", date: "2026-01-14" }
    ]
  },
  {
    id: "uuid-103",
    protocol: "Janus_protocol_2_6",
    template_name: "intellegence_template",
    template: { "name": "Intellegence", "value": "intellegence_template", "client_tone": "Defence Intelligence Analyst" },
    version: "f5g6h7j8",
    created_at: "2026-01-13",
    context_snippet: "בדיקת רקע שגרתית לעובדים חדשים בחברה...",
    video_context: "בדיקת רקע שגרתית לעובדים חדשים בחברה. נוהל סינון סטנדרטי למועמדים רגישים.",
    header_data: {
      "Classification": "INTERNAL",
      "Subject": "Batch 2026-A",
      "Date of Issue": "2026-01-13",
      "Prepared By": "HR Dept",
      "Source Material": "Zoom Call"
    },
    languages: [
      { code: "HE", name: "Hebrew", status: "Failed", error: "Reasoning generation failed (quota)", date: "2026-01-13" }
    ]
  },
  {
    id: "uuid-104",
    protocol: "Janus_protocol_2_6",
    template_name: "credibility_template",
    template: { "name": "Credibility", "value": "credibility_template", "client_tone": "Security Manager" },
    version: "k9l0m1n2",
    created_at: "2026-01-12",
    context_snippet: "HR evaluation for internal promotion to VP...",
    video_context: "HR evaluation for internal promotion to VP of Sales. Looking for leadership qualities and honesty.",
    header_data: {
      "Classification": "CONFIDENTIAL",
      "Subject": "Candidate Y",
      "Date of Issue": "2026-01-12",
      "Prepared By": "Board of Directors",
      "Source Material": "Interview"
    },
    languages: [
      { code: "EN", name: "English", status: "Success", file_path: "path/to/en_old.md", date: "2026-01-12" },
      { code: "ES", name: "Spanish", status: "Generating", date: "2026-01-14" }
    ]
  },
  {
    id: "uuid-105",
    protocol: "Janus_protocol_2_6",
    template_name: "profiling_template",
    template: { "name": "Profiling", "value": "profiling_template", "client_tone": "Occupational psychologist" },
    version: "p3q4r5s6",
    created_at: "2026-01-10",
    context_snippet: "Analyzing body language during negotiation...",
    video_context: "Analyzing body language during negotiation phase of the merger. Is the other side bluffing?",
    header_data: {
      "Classification": "TOP SECRET",
      "Subject": "Merger Discussion",
      "Date of Issue": "2026-01-10",
      "Prepared By": "Corporate Strategy",
      "Source Material": "Boardroom Cam"
    },
    languages: [
      { code: "EN", name: "English", status: "Success", file_path: "path/to/en_neg.md", date: "2026-01-10" },
      { code: "FR", name: "French", status: "Success", file_path: "path/to/fr_neg.md", date: "2026-01-10" }
    ]
  },
  {
    id: "uuid-106",
    protocol: "Janus_protocol_2_6",
    template_name: "credibility_template",
    template: { "name": "Credibility", "value": "credibility_template", "client_tone": "Security Manager" },
    version: "t7u8v9w0",
    created_at: "2026-01-08",
    context_snippet: "Context is missing or empty in this case...",
    video_context: "Context is missing or empty in this case, using default reasoning.",
    header_data: {
      "Classification": "CONFIDENTIAL",
      "Subject": "Subject (ID: 999)",
      "Date of Issue": "2026-01-08",
      "Prepared By": "Not Specified",
      "Source Material": "Video Analysis"
    },
    languages: [
      { code: "EN", name: "English", status: "Success", file_path: "path/to/en_miss.md", date: "2026-01-08" },
      { code: "DE", name: "German", status: "Success", file_path: "path/to/de_miss.md", date: "2026-01-08" },
      { code: "IT", name: "Italian", status: "Failed", error: "Translation timeout", date: "2026-01-08" }
    ]
  },
  {
    id: "uuid-107",
    protocol: "Janus_protocol_2_6",
    template_name: "intellegence_template",
    template: { "name": "Intellegence", "value": "intellegence_template", "client_tone": "Defence Intelligence Analyst" },
    version: "x1y2z3a4",
    created_at: "2026-01-14",
    context_snippet: "ניתוח מודיעיני של איומים פוטנציאליים...",
    video_context: "ניתוח מודיעיני של איומים פוטנציאליים מצד גורמים עוינים. יש להתמקד בסימנים מקדימים לפעילות חבלנית.",
    header_data: {
      "Classification": "UNCLASSIFIED",
      "Subject": "Test Subject Long",
      "Date of Issue": "2026-01-14",
      "Prepared By": "QA Team",
      "Source Material": "Test Video"
    },
    languages: [
      { code: "EN", name: "English", status: "Generating", date: "2026-01-14" },
      { code: "HE", name: "Hebrew", status: "Generating", date: "2026-01-14" }
    ]
  },
  {
    id: "uuid-108",
    protocol: "Janus_protocol_2_6",
    template_name: "credibility_template",
    template: { "name": "Credibility", "value": "credibility_template", "client_tone": "Security Manager" },
    version: "b5c6d7e8",
    created_at: "2025-12-30",
    context_snippet: "Legacy case from last year review...",
    video_context: "Legacy case from last year review. Keeping for records.",
    header_data: {
      "Classification": "CONFIDENTIAL",
      "Subject": "Review 2025",
      "Date of Issue": "2025-12-30",
      "Prepared By": "Admin",
      "Source Material": "Archive"
    },
    languages: [
      { code: "ES", name: "Spanish", status: "Success", file_path: "path/to/es_legacy.md", date: "2025-12-30" }
    ]
  },
  {
    id: "uuid-109",
    protocol: "Janus_protocol_2_6",
    template_name: "profiling_template",
    template: { "name": "Profiling", "value": "profiling_template", "client_tone": "Occupational psychologist" },
    version: "f9g0h1i2",
    created_at: "2026-01-14",
    context_snippet: "Immediate threat assessment required...",
    video_context: "Immediate threat assessment required. Subject showed aggressive behavior.",
    header_data: {
      "Classification": "CRITICAL",
      "Subject": "Threat Alpha",
      "Date of Issue": "2026-01-14",
      "Prepared By": "Security Chief",
      "Source Material": "CCTV"
    },
    languages: [
      { code: "EN", name: "English", status: "Failed", error: "Dispatch Error", date: "2026-01-14" },
      { code: "RU", name: "Russian", status: "Failed", error: "Dispatch Error", date: "2026-01-14" }
    ]
  },
  {
    id: "uuid-110",
    protocol: "Janus_protocol_2_6",
    template_name: "profiling_template",
    template: { "name": "Profiling", "value": "profiling_template", "client_tone": "Occupational psychologist" },
    version: "j3k4l5m6",
    created_at: "2026-01-14",
    context_snippet: "סימולציית איום פנימי עם הצוות האדום...",
    video_context: "סימולציית איום פנימי עם הצוות האדום. מטרת התרגיל היא לבחון את עירנות מחלקת האבטחה.",
    header_data: {
      "Classification": "INTERNAL",
      "Subject": "Red Team Simulation",
      "Date of Issue": "2026-01-14",
      "Prepared By": "IT Security",
      "Source Material": "Screen Recording"
    },
    languages: [
      { code: "EN", name: "English", status: "Generating", date: "2026-01-14" }
    ]
  }
];